import { h } from 'preact'
import { Text, withText } from 'preact-i18n'

const Min5 = withText('hint_min_5')(({hint_min_5}) =>
    <span dangerouslySetInnerHTML={{__html: hint_min_5}} />
)

export default () =>
    <div class="limba_global_hints">
        <strong><Text id="hint" /></strong>:{' '}
        <Min5 />
    </div>


// WEBPACK FOOTER //
// ./js/components/Hints.js